import { FC } from 'react';

import withBehaviors, { WithBehaviorsProps } from 'ia-react-core/~/hocs/withBehaviors';
import withShow from 'ia-react-core/~/hocs/withShow';
import compose from '../../../utils/components/#compose';
import withTransclusion from '../../../hocs/transclusion/withTransclusion';
import decorateGridComponent from '../../../hocs/grid/#decorateGridComponent';
import withSpacing from '../../../hocs/grid/withSpacing';
import Row, { RowProps } from './Row';

const ComposedRow = compose<FC<WithBehaviorsProps<RowProps>>>(
  withBehaviors,
  withShow,
  withTransclusion,
  decorateGridComponent('Row'),
  withSpacing,
)(Row);

ComposedRow.displayName = 'Row';

export * from './Row';
export default ComposedRow;
